import { render, staticRenderFns } from "./AxCardField.vue?vue&type=template&id=339ce898&scoped=true"
import script from "./AxCardField.vue?vue&type=script&lang=ts"
export * from "./AxCardField.vue?vue&type=script&lang=ts"
import style0 from "./AxCardField.vue?vue&type=style&index=0&id=339ce898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339ce898",
  null
  
)

export default component.exports